import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { updateFilters } from "../../redux/epi/epiActions";
import { ALL_SELECT_OPTION } from "../../constants";
import { clone } from "../../utils";
import { InputLabel } from "@mui/material";
import CustomizedSelect from "../Input/CustomizedSelect";
import Button from "@mui/material/Button";
import Badge from "@mui/material/Badge";
import "./FollowupEquipmentsEPIFilters.css";

class FollowupEquipmentsEPIFilters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    handleClick() {
        this.setState({
            open: !this.state.open,
        });
    }

    toggleArrow = () => {
        return this.state.open ? (
            <i className="material-icons">keyboard_arrow_up</i>
        ) : (
            <i className="material-icons">keyboard_arrow_down</i>
        );
    };

    resetFilter() {
        let newFilters = clone(this.props.epiFilters[this.props.filtersInstance]);
        if (this.props.coworkersEquipmentsEPI) {
            newFilters.employees = [ALL_SELECT_OPTION];
            newFilters.departments = [ALL_SELECT_OPTION];
        }
        newFilters.categories = [ALL_SELECT_OPTION];
        newFilters.models = [ALL_SELECT_OPTION];
        newFilters.brands = [ALL_SELECT_OPTION];
        newFilters.serialNumbers = [ALL_SELECT_OPTION];
        this.props.updateFilters(newFilters);
    }

    employeeFilterChange(e) {
        let newFilters = clone(this.props.epiFilters[this.props.filtersInstance]);
        newFilters.employees = e.target.value;
        if (newFilters.employees[newFilters.employees.length - 1] === ALL_SELECT_OPTION) {
            newFilters.employees = [ALL_SELECT_OPTION];
            this.props.updateFilters(newFilters);
            return;
        }
        if (newFilters.employees[0] === ALL_SELECT_OPTION) {
            newFilters.employees.splice(0, 1);
        }
        this.props.updateFilters(newFilters);
    }

    departmentFilterChange(e) {
        let newFilters = clone(this.props.epiFilters[this.props.filtersInstance]);
        newFilters.departments = e.target.value;
        if (newFilters.departments[newFilters.departments.length - 1] === ALL_SELECT_OPTION) {
            newFilters.departments = [ALL_SELECT_OPTION];
            this.props.updateFilters(newFilters);
            return;
        }
        if (newFilters.departments[0] === ALL_SELECT_OPTION) {
            newFilters.departments.splice(0, 1);
        }
        this.props.updateFilters(newFilters);
    }

    equipmentTypesFilterChange(e) {
        let newFilters = clone(this.props.epiFilters[this.props.filtersInstance]);
        newFilters.equipmentTypes = e.target.value;
        if (newFilters.equipmentTypes[newFilters.equipmentTypes.length - 1] === ALL_SELECT_OPTION) {
            newFilters.equipmentTypes = [ALL_SELECT_OPTION];
            this.props.updateFilters(newFilters);
            return;
        }
        if (newFilters.equipmentTypes[0] === ALL_SELECT_OPTION) {
            newFilters.equipmentTypes.splice(0, 1);
        }
        this.props.updateFilters(newFilters);
    }

    categoryFilterChange(e) {
        let newFilters = clone(this.props.epiFilters[this.props.filtersInstance]);
        newFilters.categories = e.target.value;
        if (newFilters.categories[newFilters.categories.length - 1] === ALL_SELECT_OPTION) {
            newFilters.categories = [ALL_SELECT_OPTION];
            this.props.updateFilters(newFilters);
            return;
        }
        if (newFilters.categories[0] === ALL_SELECT_OPTION) {
            newFilters.categories.splice(0, 1);
        }
        this.props.updateFilters(newFilters);
    }

    modelFilterChange(e) {
        let newFilters = clone(this.props.epiFilters[this.props.filtersInstance]);
        newFilters.models = e.target.value;
        if (newFilters.models[newFilters.models.length - 1] === ALL_SELECT_OPTION) {
            newFilters.models = [ALL_SELECT_OPTION];
            this.props.updateFilters(newFilters);
            return;
        }
        if (newFilters.models[0] === ALL_SELECT_OPTION) {
            newFilters.models.splice(0, 1);
        }
        this.props.updateFilters(newFilters);
    }

    brandFilterChange(e) {
        let newFilters = clone(this.props.epiFilters[this.props.filtersInstance]);
        newFilters.brands = e.target.value;
        if (newFilters.brands[newFilters.brands.length - 1] === ALL_SELECT_OPTION) {
            newFilters.brands = [ALL_SELECT_OPTION];
            this.props.updateFilters(newFilters);
            return;
        }
        if (newFilters.brands[0] === ALL_SELECT_OPTION) {
            newFilters.brands.splice(0, 1);
        }
        this.props.updateFilters(newFilters);
    }

    serialNumberFilterChange(e) {
        let newFilters = clone(this.props.epiFilters[this.props.filtersInstance]);
        newFilters.serialNumbers = e.target.value;
        if (newFilters.serialNumbers[newFilters.serialNumbers.length - 1] === ALL_SELECT_OPTION) {
            newFilters.serialNumbers = [ALL_SELECT_OPTION];
            this.props.updateFilters(newFilters);
            return;
        }
        if (newFilters.serialNumbers[0] === ALL_SELECT_OPTION) {
            newFilters.serialNumbers.splice(0, 1);
        }
        this.props.updateFilters(newFilters);
    }

    render() {
        let equipmentsEPI = this.props.equipmentsEPI;
        let epiFilters = this.props.epiFilters[this.props.filtersInstance];
        let rowsEmployeeList = [];
        let rowsDepartmentList = [];
        let rowsEquipmentTypesList = [];
        let rowsCategoryList = [
            <MenuItem key={0} value={ALL_SELECT_OPTION}>
                {"Tous"}
            </MenuItem>,
        ];
        let rowsModelList = [
            <MenuItem key={0} value={ALL_SELECT_OPTION}>
                {"Tous"}
            </MenuItem>,
        ];
        let rowsBrandList = [
            <MenuItem key={0} value={ALL_SELECT_OPTION}>
                {"Tous"}
            </MenuItem>,
        ];
        let rowsSerialNumberList = [
            <MenuItem key={0} value={ALL_SELECT_OPTION}>
                {"Tous"}
            </MenuItem>,
        ];

        if (this.props.coworkersEquipmentsEPI) {
            rowsEmployeeList = [
                <MenuItem key={0} value={ALL_SELECT_OPTION}>
                    {"Tous"}
                </MenuItem>,
            ];
            rowsDepartmentList = [
                <MenuItem key={0} value={ALL_SELECT_OPTION}>
                    {"Tous"}
                </MenuItem>,
            ];
            rowsEquipmentTypesList = [
                <MenuItem key={0} value={ALL_SELECT_OPTION}>
                    {"Tous"}
                </MenuItem>,
            ];
            if (equipmentsEPI && equipmentsEPI.length > 0) {
                let employeesList = [...new Set(equipmentsEPI.map((e) => e.emp_id))];
                let distinctEmployeesList = [
                    ...new Map(employeesList.map((employee) => [employee["id"], employee])).values(),
                ];
                distinctEmployeesList.sort((a, b) => a.last_name.trim().localeCompare(b.last_name.trim()));
                let i = 1;
                distinctEmployeesList.forEach((e) => {
                    rowsEmployeeList.push(
                        <MenuItem key={i} value={e.id}>
                            {e.first_name + " " + e.last_name}
                        </MenuItem>
                    );
                    i = i + 1;
                });
                /* Filtre département dissimulé pour le moment */
                // let departmentsList = [...new Set(equipmentsEPI.map(e => e.department_id))];
                // let distinctDepartmentsList = [
                // 	...new Map(departmentsList.map((department) => [department["id"], department])).values(),];
                // let j = 1;
                // distinctDepartmentsList.forEach((d) => {
                // 	rowsDepartmentList.push(
                // 		<MenuItem key={j} value={d.id}>
                // 			{d.name}
                // 		</MenuItem>
                // 	)
                // 	j = j + 1;
                // });
                rowsEquipmentTypesList.push(
                    <MenuItem key={1} value={true}>
                        {"Commun"}
                    </MenuItem>
                );
                rowsEquipmentTypesList.push(
                    <MenuItem key={2} value={false}>
                        {"Individuel"}
                    </MenuItem>
                );
            }
        }

        if (equipmentsEPI && equipmentsEPI.length > 0) {
            let categoriesList = [...new Set(equipmentsEPI.map((e) => e.equipment_id.name.trim()))];
            let i = 1;
            categoriesList.sort((a, b) => a.trim().localeCompare(b.trim()));
            categoriesList.forEach((c) => {
                rowsCategoryList.push(
                    <MenuItem key={i} value={c}>
                        {c}
                    </MenuItem>
                );
                i = i + 1;
            });
        }

        if (equipmentsEPI && equipmentsEPI.length > 0) {
            let modelsList = [...new Set(equipmentsEPI.map((e) => e.model.trim()))];
            let i = 1;
            modelsList.sort((a, b) => a.trim().localeCompare(b.trim()));
            modelsList.forEach((m) => {
                rowsModelList.push(
                    <MenuItem key={i} value={m}>
                        {m}
                    </MenuItem>
                );
                i = i + 1;
            });
        }

        if (equipmentsEPI && equipmentsEPI.length > 0) {
            let brandsList = [...new Set(equipmentsEPI.map((e) => e.brand.trim()))];
            let i = 1;
            brandsList.sort((a, b) => a.trim().localeCompare(b.trim()));
            brandsList.forEach((b) => {
                rowsBrandList.push(
                    <MenuItem key={i} value={b}>
                        {b}
                    </MenuItem>
                );
                i = i + 1;
            });
        }

        if (equipmentsEPI && equipmentsEPI.length > 0) {
            let serialNumbersList = [...new Set(equipmentsEPI.map((e) => e.serial_number.trim()))];
            let i = 1;
            serialNumbersList.sort((a, b) => a.trim().localeCompare(b.trim()));
            serialNumbersList.forEach((s) => {
                rowsSerialNumberList.push(
                    <MenuItem key={i} value={s}>
                        {s}
                    </MenuItem>
                );
                i = i + 1;
            });
        }

        let activeFilter = 0;
        for (var key in epiFilters) {
            if (epiFilters[key] && epiFilters[key] != "ALL") {
                activeFilter++;
            }
        }

        return (
            <div>
                <div className="col-lg-3 col-md-12 col-sm-12 col-12 control-margin-top text-center">
                    <div style={{ display: "inline-block" }}>
                        <Badge color="secondary" badgeContent={activeFilter}>
                            <Button
                                color="primary"
                                onClick={this.handleClick.bind(this)}
                                variant="contained"
                                style={{ marginBottom: "10px" }}
                            >
                                <i className="material-icons">
                                    <span>filter_list</span>
                                </i>
                                <span>Filtres</span>
                                {this.toggleArrow()}
                            </Button>
                        </Badge>
                        <Button
                            color="primary"
                            onClick={this.resetFilter.bind(this)}
                            variant="contained"
                            style={{ marginBottom: "10px", marginLeft: "15px" }}
                        >
                            Réinitialiser
                        </Button>
                    </div>
                </div>
                <div className="row sub-header">
                    {this.state.open ? (
                        <div>
                            {this.props.coworkersEquipmentsEPI ? (
                                <FormControl className="col-lg-3 col-md-6 col-sm-6 col-12 control-padding-right-padding control-margin-top">
                                    <InputLabel
                                        id="employee-filter-label"
                                        className="placeholder-select-light-background"
                                        sx={{ color: "#333333 !important" }}
                                    >
                                        Employé
                                    </InputLabel>
                                    <CustomizedSelect
                                        label="Employé"
                                        labelId="employee-filter-label"
                                        id="employee-filter"
                                        inputProps={{ name: "employee-filter", id: "employee-filter" }}
                                        placeholder="Employee"
                                        className="full_size select-light-background"
                                        menuclasses="select-popup"
                                        multiple
                                        onChange={this.employeeFilterChange.bind(this)}
                                        value={epiFilters.employees}
                                    >
                                        {rowsEmployeeList}
                                    </CustomizedSelect>
                                </FormControl>
                            ) : null}
                            {/* Filtre département dissimulé pour le moment */}
                            {/* {this.props.coworkersEquipmentsEPI ? 
								<FormControl className="col-lg-3 col-md-6 col-sm-6 col-12 control-padding-right-padding control-margin-top">
									<InputLabel id="department-filter-label" className="placeholder-select-light-background" sx={{color: "#333333 !important"}}>Département</InputLabel>
									<CustomizedSelect
										label="Département"
										labelId="department-filter-label"
										id="department-filter"
										inputProps={{ name: "department-filter", id: "department-filter" }}
										placeholder="Department"
										className="full_size select-light-background"
										menuclasses="select-popup"
										multiple
										onChange={this.departmentFilterChange.bind(this)}
										value={epiFilters.departments}
									>
										{rowsDepartmentList}
									</CustomizedSelect>
								</FormControl>
								: null
							} */}
                            <FormControl className="col-lg-3 col-md-6 col-sm-6 col-12 control-padding-right-padding control-margin-top">
                                <InputLabel
                                    id="category-filter-label"
                                    className="placeholder-select-light-background"
                                    sx={{ color: "#333333 !important" }}
                                >
                                    Catégorie
                                </InputLabel>
                                <CustomizedSelect
                                    label="Catégorie"
                                    labelId="category-filter-label"
                                    id="category-filter"
                                    inputProps={{ name: "category-filter", id: "category-filter" }}
                                    placeholder="Category"
                                    className="full_size select-light-background"
                                    menuclasses="select-popup"
                                    multiple
                                    onChange={this.categoryFilterChange.bind(this)}
                                    value={epiFilters.categories}
                                >
                                    {rowsCategoryList}
                                </CustomizedSelect>
                            </FormControl>
                            <FormControl className="col-lg-3 col-md-6 col-sm-6 col-12 control-padding-right-padding control-margin-top">
                                <InputLabel
                                    id="model-filter-label"
                                    className="placeholder-select-light-background"
                                    sx={{ color: "#333333 !important" }}
                                >
                                    Modèle
                                </InputLabel>
                                <CustomizedSelect
                                    label="Modèle"
                                    labelId="model-filter-label"
                                    id="model-filter"
                                    inputProps={{ name: "model-filter", id: "model-filter" }}
                                    placeholder="Model"
                                    className="full_size select-light-background"
                                    menuclasses="select-popup"
                                    multiple
                                    onChange={this.modelFilterChange.bind(this)}
                                    value={epiFilters.models}
                                >
                                    {rowsModelList}
                                </CustomizedSelect>
                            </FormControl>
                            <FormControl className="col-lg-3 col-md-6 col-sm-6 col-12 control-padding-right-padding control-margin-top">
                                <InputLabel
                                    id="brand-filter-label"
                                    className="placeholder-select-light-background"
                                    sx={{ color: "#333333 !important" }}
                                >
                                    Marque
                                </InputLabel>
                                <CustomizedSelect
                                    label="Marque"
                                    labelId="brand-filter-label"
                                    id="brand-filter"
                                    inputProps={{ name: "brand-filter", id: "brand-filter" }}
                                    placeholder="Brand"
                                    className="full_size select-light-background"
                                    menuclasses="select-popup"
                                    multiple
                                    onChange={this.brandFilterChange.bind(this)}
                                    value={epiFilters.brands}
                                >
                                    {rowsBrandList}
                                </CustomizedSelect>
                            </FormControl>
                            <FormControl className="col-lg-3 col-md-6 col-sm-6 col-12 control-padding-right-padding control-margin-top">
                                <InputLabel
                                    id="serial-number-filter-label"
                                    className="placeholder-select-light-background"
                                    sx={{ color: "#333333 !important" }}
                                >
                                    Numéro de série
                                </InputLabel>
                                <CustomizedSelect
                                    label="Numéro de série"
                                    labelId="serial-number-filter-label"
                                    id="serial-number-filter"
                                    inputProps={{ name: "serial-number-filter", id: "serial-number-filter" }}
                                    placeholder="SerialNumber"
                                    className="full_size select-light-background"
                                    menuclasses="select-popup"
                                    multiple
                                    onChange={this.serialNumberFilterChange.bind(this)}
                                    value={epiFilters.serialNumbers}
                                >
                                    {rowsSerialNumberList}
                                </CustomizedSelect>
                            </FormControl>
                            {this.props.coworkersEquipmentsEPI ? (
                                <FormControl className="col-lg-3 col-md-6 col-sm-6 col-12 control-padding-right-padding control-margin-top">
                                    <InputLabel
                                        id="equipment-types-filter-label"
                                        className="placeholder-select-light-background"
                                        sx={{ color: "#333333 !important" }}
                                    >
                                        {"Type d'équipement"}
                                    </InputLabel>
                                    <CustomizedSelect
                                        label="Type d'équipement"
                                        labelId="equipment-types-filter-label"
                                        id="equipment-types-filter"
                                        inputProps={{ name: "equipment-types-filter", id: "equipment-types-filter" }}
                                        placeholder="
										Equipment Types"
                                        className="full_size select-light-background"
                                        menuclasses="select-popup"
                                        multiple
                                        onChange={this.equipmentTypesFilterChange.bind(this)}
                                        value={epiFilters.equipmentTypes}
                                    >
                                        {rowsEquipmentTypesList}
                                    </CustomizedSelect>
                                </FormControl>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        equi: state.equipmentsEPI,
        epiFilters: state.equipmentsEPI.epiFilters,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        updateFilters: (filters) =>
            dispatch(updateFilters(filters, ownProps.myEquipmentsEPI, ownProps.coworkersEquipmentsEPI)),
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(FollowupEquipmentsEPIFilters);
